export enum AppSource {
	Public = 'Public',
	Internal = 'Internal'
}

// Single source of truth for the NSTEP version (appears when hovering the NSTEP logo in the UI)
export const APP_VERSION = '2.3.2';

export class Enviroment {
	target!: string;
	disableConsoleLogs!: boolean;
	logRequests!: boolean;
	expandedLogRequests!: boolean;
	angularRouterBaseHref!: string;
	appName!: AppSource;
	apiUrl!: string; // use relative or full url
	metricsCallInterval!: number; // miliseconds
	appVersion!: string;
}